export class BillingAccountInformation{

    constructor(){}

    // ID:number;
    // Name:string;
    // Email:string;
    // Phone:string;
    // Address:string;
    // Status:number;
    // CreatedOn:Date;
    // UpdatedOn:Date
    // UserID:number;
    id:number;
    name:string;
    email:string;
    phone:string;
    address:string;
    status:number;
    createdOn:Date;
    updatedOn:Date
    userID:number;

}

export class MonthlyBill{
    constructor(){}
    invoiceID:string;
    paid:boolean;
    title:string;
    total:number;
    ready:boolean;
}

export class MonthlyBillItems{
    constructor(){};
    id:number;
    monthlyBIlInvoiceID:number;
    numberOfStudents: number;
    numberOfStudentsCost: number;
    schoolAccountTierConfigurationID: number;
    storage: number;
    storageCost: number;
    total: number;
    date: Date;
    dateString: string;
}

